<template>
  <div class="partners">
    <div>
      <img src="../../public/img/unilever.png" alt="Verizon">
    </div>
        <div>
      <img src="../../public/img/mercedes.png" alt="Verizon">
    </div>
        <div>
      <img src="../../public/img/bmo.png" alt="Verizon">
    </div>
        <div>
      <img src="../../public/img/ab.png" alt="Verizon">
    </div>
        <div>
      <img src="../../public/img/verizon.png" alt="Verizon">
    </div>
  </div>
</template>

<script>
export default {
  name: "partners",
  data() {
    return {
      partners: [
        {
          title: "Verizon",
          image: "./public/img/unilever.png"
        },
        {
          title: "Verizon",
          image: "../../public/img/mercedes.png"
        },
        {
          title: "Verizon",
          image: "../../public/img/bmo.png"
        },
        {
          title: "Verizon",
          image: "../../public/img/ab.png"
        },
        {
          title: "Verizon",
          image: "../../public/img/verizon.png"
        }
      ]
    };
  }
};
</script>

<style lang="scss" scoped>
.partners {
  display: flex;
  flex-wrap: nowrap;
  padding: 20px 60px 20px 118px;
  overflow: hidden;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  max-width: 100%;
  > div {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 88px;
    flex:1;
    max-width: 246px;
  }
}
</style>